<template>
  <div>
    <Panel :module="panel.module" :title="panel.title" :showFilter="panel.showFilter" :showSearch="panel.showSearch"
           :showButtons="panel.showButtons">
      <div slot="content-main">
        <br/>
        <Alert type="info">
          <span>
            Por questões de performance, são carregados os <b>100</b> registros mais recentes.
            Caso precise de mais, solicite ao suporte.
          </span>
        </Alert>
        <TimelineLog/>
      </div>
    </Panel>
  </div>
</template>

<script>
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel";
import TimelineLog from "../../../components/modules/adm/audit-log/TimelineLog.vue";

import {mapMutations} from "vuex";

export default {
  name: "AuditView",
  components: {
    Alert,
    Panel,
    TimelineLog,
  },
  data() {
    return {
      panel: {
        module: "Adm",
        title: "Auditoria",
        showFilter: false,
        showSearch: false,
        showButtons: false,
      },
    };
  },
  mounted() {
    this.removeLoading(["panel"]);
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
  },
};
</script>

